let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c8iqx")).then(() => parcelRequire('33cWm'));